module.exports = __webpack_public_path__ + "static/media/circle.9796e15d.svg";